<template>
  <footer class="app-footer">
    <div class="footer-content">
      <!-- Main Footer Section -->
      <div class="footer-main">
        <div class="footer-brand">
          <h3 class="footer-title">TestHR</h3>
          <p class="footer-description">
            Професійна система тестування та оцінки персоналу
          </p>
        </div>
        
        <div class="footer-links">
          <div class="footer-section">
            <h4 class="footer-section-title"></h4>
            <ul class="footer-link-list">
             
            </ul>
          </div>
          
          <div class="footer-section">
            <h4 class="footer-section-title">Підтримка</h4>
            <ul class="footer-link-list">
              <li><a href="#" class="footer-link">Довідка</a></li>
              <li><a href="#" class="footer-link">Контакти</a></li>
              <li><a href="#" class="footer-link">FAQ</a></li>
            </ul>
          </div>
          
          <div class="footer-section">
            <h4 class="footer-section-title">Про систему</h4>
            <ul class="footer-link-list">
              <li><a href="#" class="footer-link">Про нас</a></li>
              <li><a href="#" class="footer-link">Політика конфіденційності</a></li>
              <li><a href="#" class="footer-link">Умови використання</a></li>
            </ul>
          </div>
        </div>
      </div>
      
      <!-- Footer Bottom -->
      <div class="footer-bottom">
        <div class="footer-info">
          <div class="footer-version">
            <span class="version-number">v{{ version }}</span>
            <span class="build-date">{{ formatBuildDate(buildDate) }}</span>
          </div>
          <p class="footer-copyright">
            © {{ currentYear }} TestHR. Всі права захищені.
          </p>
        </div>
        
        <div class="footer-actions">
          <ThemeToggle 
            class="footer-theme-toggle" 
            @theme-changed="onThemeChanged"
          />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex'
import ThemeToggle from './ThemeToggle.vue'

export default {
  name: 'Footer',
  components: {
    ThemeToggle
  },
  computed: {
    ...mapState(['currentUser', 'version', 'buildDate', 'currentTheme']),
    isAdmin() {
      return this.currentUser?.role === 'admin'
    },
    currentYear() {
      return new Date().getFullYear()
    }
  },
  methods: {
    formatBuildDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleDateString('uk-UA');
    },
    
    onThemeChanged(newTheme) {
      // Emit theme change event to parent
      this.$emit('theme-changed', newTheme)
    }
  }
}
</script>

<style scoped>
.app-footer {
  background: var(--surface-card);
  border-top: 1px solid var(--surface-border);
  color: var(--text-color);
  margin-top: auto;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

/* Main Footer Section */
.footer-main {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 3rem;
  margin-bottom: 2rem;
}

.footer-brand {
  max-width: 300px;
}

.footer-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--primary-color);
  margin: 0 0 1rem 0;
  transition: color 0.3s ease;
}

.footer-description {
  color: var(--text-color-secondary);
  line-height: 1.6;
  margin: 0;
  transition: color 0.3s ease;
}

.footer-links {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.footer-section-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-color);
  margin: 0 0 1rem 0;
  transition: color 0.3s ease;
}

.footer-link-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-link-list li {
  margin-bottom: 0.5rem;
}

.footer-link {
  color: var(--text-color-secondary);
  text-decoration: none;
  transition: color 0.2s ease;
  display: inline-block;
}

.footer-link:hover {
  color: var(--primary-color);
}

.footer-link.router-link-active {
  color: var(--primary-color);
  font-weight: 500;
}

/* Footer Bottom */
.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 2rem;
  border-top: 1px solid var(--surface-border);
}

.footer-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.footer-version {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.version-number {
  font-size: 0.7rem;
  font-weight: 600;
  color: var(--primary-color);
  background: var(--primary-50);
  padding: 0.125rem 0.25rem;
  border-radius: 0.25rem;
  line-height: 1;
  transition: all 0.3s ease;
}

.build-date {
  font-size: 0.6rem;
  color: var(--text-color-secondary);
  line-height: 1;
  transition: color 0.3s ease;
}

.footer-copyright {
  color: var(--text-color-secondary);
  font-size: 0.875rem;
  margin: 0;
  transition: color 0.3s ease;
}

.footer-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.footer-theme-toggle {
  transform: scale(0.9);
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer-main {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .footer-links {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }
  
  .footer-bottom {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  
  .footer-version {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .footer-content {
    padding: 1.5rem 1rem;
  }
  
  .footer-links {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .footer-brand {
    text-align: center;
  }
  
  .footer-title {
    font-size: 1.25rem;
  }
}


</style>
